import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '../../assets/images/theme/loading.gif'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-people-fill text-center friOpacity1",
    style: {"font-size":"70px"}
  })
], -1)
const _hoisted_2 = {
  class: "text-center fw-bold",
  style: {"font-size":"30px","color":"#999"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "form-body p-0 m-0 friBackWhite vh-100" }
const _hoisted_5 = {
  key: 0,
  style: {"padding-bottom":"150px"}
}
const _hoisted_6 = {
  key: 0,
  class: "text-white fw-bold"
}
const _hoisted_7 = {
  key: 1,
  class: "text-white fw-bold"
}
const _hoisted_8 = { class: "fs-6" }
const _hoisted_9 = { class: "text-xs3" }
const _hoisted_10 = {
  key: 0,
  class: "text-xs3"
}
const _hoisted_11 = {
  key: 1,
  class: "text-xs3"
}
const _hoisted_12 = {
  key: 1,
  class: "pt-5"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, "No ha creado ningún cliente.", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 1,
  class: "text-center mt-5 w-100"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"150px","margin-top":"80px"}
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-person-circle text-center friColor6",
    style: {"font-size":"60px"}
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-center fw-bold text-dark friColor6",
  style: {"font-size":"20px"}
}, "Nuevo usuario", -1)
const _hoisted_20 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center mt-5 pt-3"
}
const _hoisted_21 = { class: "friUserCircle2 friBack1" }
const _hoisted_22 = { class: "mx-5 fs-3 text-center" }
const _hoisted_23 = {
  key: 0,
  class: "text-xs3 text-center text-danger"
}
const _hoisted_24 = { class: "mt-5" }
const _hoisted_25 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.isMobile ? 'text-left' : 'ms-5 text-center'),
    style: _normalizeStyle(!_ctx.isMobile ? 'padding-top: 20px' : '')
  }, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        (_ctx.layout.clients)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(Object.keys(_ctx.layout.clients.clients).length), 1))
          : _createCommentVNode("", true),
        _createTextVNode(" usuarios")
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.layout.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.layout.clients && _ctx.layout.clients.clients && Object.keys(_ctx.layout.clients.clients).length)
              ? (_openBlock(), _createBlock(_component_ion_list, {
                  key: 0,
                  style: {"background-color":"#fff !important"}
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.clients.clients, (client, clientId) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        detail: "",
                        key: clientId,
                        style: {"--ion-item-border-color":"#e4e3e3"},
                        onClick: ($event: any) => (_ctx.$router.push({ path: '/client/' + clientId, query: { section:  'dashboard' } })),
                        class: "cursor-pointer ps-2 pe-3 mb-3"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_avatar, {
                            slot: "start",
                            style: {"width":"60px","height":"50px"},
                            class: "text-center"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: _normalizeClass(["friUserCircle", client.active ? client.role == 'agent' ?  'friBack3' : 'friBack1' : 'friBack12'])
                              }, [
                                (client.role == 'agent')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, "A"))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_7, "C"))
                              ], 2)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("h2", _hoisted_8, _toDisplayString(client.first) + " " + _toDisplayString(client.last), 1),
                              _createElementVNode("div", _hoisted_9, _toDisplayString(client.email), 1),
                              (client.role)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (client.role == 'client')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, "Cliente"))
                                      : (client.role == 'agent')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Agente"))
                                        : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17)),
      _createVNode(_component_ion_modal, {
        "is-open": _ctx.$router.currentRoute.value.path == '/clients/add',
        "backdrop-dismiss": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, null, {
            default: _withCtx(() => [
              (!_ctx.layout.newClient.first)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_18,
                    _hoisted_19
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.layout.newClient.first[0]) + _toDisplayString(_ctx.layout.newClient.last[0]), 1)
                  ])),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_ion_list, {
                  class: _normalizeClass([_ctx.isMobile ? '' : 'mx-5', "mt-0 pt-0"])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      class: "border-none",
                      style: {"--ion-item-border-color":"#ccc"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_select, {
                          interface: "popover",
                          modelValue: _ctx.layout.newClient.role,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.layout.newClient.role) = $event)),
                          class: "border-none"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_select_option, { value: 'client' }, {
                              default: _withCtx(() => [
                                _createTextVNode("Cliente")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_select_option, { value: 'agent' }, {
                              default: _withCtx(() => [
                                _createTextVNode("Agente")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      class: "border-none",
                      style: {"--ion-item-border-color":"#ccc"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          position: "floating",
                          class: "fs-6"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Nombre *")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "text",
                          modelValue: _ctx.layout.newClient.first,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.layout.newClient.first) = $event)),
                          autocomplete: "off"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      class: "border-none",
                      style: {"--ion-item-border-color":"#ccc"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          position: "floating",
                          class: "fs-6"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Apellidos *")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "text",
                          modelValue: _ctx.layout.newClient.last,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.layout.newClient.last) = $event)),
                          autocomplete: "off"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      lines: "full",
                      class: "border-none",
                      style: {"--ion-item-border-color":"#ccc"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, {
                          position: "floating",
                          class: "fs-6"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Documento *")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_input, {
                          type: "text",
                          modelValue: _ctx.layout.newClient.document,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.layout.newClient.document) = $event)),
                          autocomplete: "off"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              lines: "full",
                              class: "border-none",
                              style: {"--ion-item-border-color":"#ccc"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, {
                                  position: "floating",
                                  class: "fs-6"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Email *")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  type: "email",
                                  modelValue: _ctx.layout.newClient.email,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.layout.newClient.email) = $event)),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              lines: "full",
                              class: "border-none",
                              style: {"--ion-item-border-color":"#ccc"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, {
                                  position: "floating",
                                  class: "fs-6"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Repite Email *")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  type: "email",
                                  modelValue: _ctx.layout.newClient.email2,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.layout.newClient.email2) = $event)),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              lines: "full",
                              class: "border-none",
                              style: {"--ion-item-border-color":"#ccc"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, {
                                  position: "floating",
                                  class: "fs-6"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Contraseña *")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  type: "password",
                                  modelValue: _ctx.layout.newClient.password,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.layout.newClient.password) = $event)),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              lines: "full",
                              class: "border-none",
                              style: {"--ion-item-border-color":"#ccc"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, {
                                  position: "floating",
                                  class: "fs-6"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Repite contraseña *")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  type: "password",
                                  modelValue: _ctx.layout.newClient.password2,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.layout.newClient.password2) = $event)),
                                  autocomplete: "off"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.layout.newClient.password != _ctx.layout.newClient.password2)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Las contraseñas no coinciden"))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("button", {
                    class: "button px-5 py-2 m-0 mt-0 bg-light",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$router.push('/clients/')))
                  }, "Cancelar"),
                  _createElementVNode("button", {
                    class: "button px-5 py-2 ms-3 fw-bold friBack1 text-white outline-none",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.saveClient()))
                  }, "Crear")
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"])
    ])
  ], 6))
}